import { DxDataGridModule, DxPopupModule, DxCheckBoxModule, DxButtonModule, DxTagBoxModule } from 'devextreme-angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectionSetRendererComponent } from './selection-set-renderer.component';
import { DropdownModule } from 'src/app/widgets/dropdown/dropdown.component';



@NgModule({
  declarations: [
    SelectionSetRendererComponent
  ],
	exports: [
		SelectionSetRendererComponent
	],
  imports: [
    CommonModule,

		DropdownModule,

		DxDataGridModule,
		DxPopupModule,
		DxCheckBoxModule,
		DxButtonModule,
		DxTagBoxModule,
  ]
})
export class SelectionSetRendererModule { }
